import { io, type Socket } from 'socket.io-client';
import { env } from '../api/env';
import { getActiveAuthScope } from '../api/client';
import { getTokenStore } from '../api/token-store';

// One shared chat socket per active scope. Connects lazily on first use.
let socket: Socket | null = null;
let currentScope: string | null = null;

export function getSocket(): Socket {
  const scope = getActiveAuthScope();
  if (socket && currentScope === scope) return socket;
  if (socket) {
    socket.disconnect();
    socket = null;
  }
  currentScope = scope;

  socket = io(`${env.API_URL}/chat`, {
    autoConnect: false,
    transports: ['websocket', 'polling'],
    withCredentials: true,
    auth: (cb: (data: any) => void) => {
      const activeScope = getActiveAuthScope();
      const currentToken = getTokenStore().getAccessToken();
      cb({
        scope: activeScope,
        ...(currentToken && currentToken !== 'cookie-session' ? { token: currentToken } : {}),
      });
    },
  });
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
    currentScope = null;
  }
}
